module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/6ft-54a95a2ad1b13c189db0a4c0df63847c.png";